<template>
  <div class="container">
    <img
      class="containerBg"
      src="https://p2.ssl.qhimg.com/t110b9a9301a78938c92f4320f6.png"
      alt=""
    />
    <div class="agenda">
      <div class="agendaTop">
        <div @click="goBack" class="agendaTopBack">
          <LeftOutlined :style="{ fontSize: '16px' }" />
          <span class="agendaTopBackText">返回</span>
        </div>
        <div class="agendaTopNav">
          <div class="agendaTopNavTitle">
            <div>
              {{ obj?.title }}
              <p class="agendaTopNavTitleTab">{{ obj?.activity_type }}</p>
            </div>
            <!-- <button v-if="obj?.video_url" class="custom-btn btn" @click="handleJump(obj?.video_url)"><span>{{obj?.video_live_status==1?'观看直播':'观看回放'}}</span></button> -->
          </div>
          <div class="agendaTopNavDet">
            <div>
              <ClockCircleOutlined />
              <span class="agendaTopNavDetTime">{{ obj?.meet_date }}</span>
              <span class="agendaTopNavDetTime"
                >{{ extractTime(obj?.start_date) }}-{{ extractTime(obj?.end_date) }}</span
              >
            </div>
            <div class="agendaTopNavDetImg">
              <!-- <EnvironmentOutlined /> -->
              <img
                src="https://p0.ssl.qhimg.com/t110b9a9301d135a4c49a183017.png"
                alt=""
                class="agendaTopNavDetAddicon"
              />
              <span class="agendaTopNavDetTime">{{ obj?.address }}</span>
            </div>
          </div>
          <div class="agendaTopNavDesc">
            {{ obj?.description }}
          </div>
        </div>
      </div>
      <div class="agendaBottom">
        <div class="agendaBottomTitle">论坛议程
          <span class="agendaBottomTitleDesc">*具体议程时间以实际为准</span>
        </div>
        <div v-for="(item, index) in obj?.agendas" :key="index" class="agendaBottomBox">
          <div class="agendaBottomBoxLeft">
            <div class="agendaBottomBoxLine"></div>
            <span class="agendaBottomBoxCircle"></span>
            <span class="agendaBottomBoxTime"
              >{{ extractHourAndMinute(item.start_time) }}-{{
                extractHourAndMinute(item.end_time)
              }}</span
            >
            <a-tooltip>
              <template #title >{{ item.title.replace(/<br>/g, '') }}</template>
              <span class="agendaBottomBoxTitle" v-html="item.title"></span>
            </a-tooltip>
          </div>
          <div class="guestBox">
            <span class="expertList" v-if="item.speakers?.length>0">
              <div class="expertListItem" v-for="(itema, indexa) in item.speakers" :key="indexa">
                <div class="expertListItemIcon">
                  <img v-if="itema.image_url" :src="itema.image_url" alt="" />
                  <img v-else src="https://p0.ssl.qhimg.com/t110b9a9301e7bf54d9a3355999.png" alt="">
                </div>
                <div class="expertListItemDesc">
                  <div class="expertListItemName">{{ itema.name }}</div>
                  <a-tooltip>
                    <template #title>{{ itema.bio }}</template>
                    <div class="expertListItemTitle">{{ itema.bio }}</div>
                  </a-tooltip>
                </div>
              </div>
            </span>
          </div>
          <!-- v-if="item.extends" -->
          <span
            v-if="item.extends"
            class="agendaBottomBoxRight"
            @click="handleJump(JSON.parse(item.extends).pdf_url)"
          >
            <img
              src="https://p2.ssl.qhimg.com/t110b9a93018a91148487a4f07d.png"
              alt=""
              class="agendaBottomBoxRightActive"
            />
            <img
              src="https://p2.ssl.qhimg.com/t110b9a930131b2ffad91cf0cfb.png"
              alt=""
              class="agendaBottomBoxRightIcon"
            />
            思维导图
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { LeftOutlined, ClockCircleOutlined } from '@ant-design/icons-vue'
import { URLparams } from '@/utils/help.js'
import { agendaDetail } from '@/mock/2026/iscAgenda.js';

const obj = ref({})
const id = URLparams.get('id')

const showArrow = ref(false)

onBeforeMount(() => {
  fetch()
})

const goBack = () => {
  const baseUrl=window.location.origin
  window.open(`${baseUrl}/new/2026/agenda.html`, '_self')
}

const handleJump = (url) => {
  window.open(url)
}
const handleData = (str) => {
  return str.split(' ')[0].split('-').join('/')
}

function extractHourAndMinute(timeString) {
  const match = timeString.match(/^(\d{2}:\d{2})/)
  return match ? match[1] : ''
}
function extractTime(dateString) {
  if (!dateString) return ''
  return dateString.split(' ')[1].substring(0, 5)
}
const fetch = () => {
    const data = getAgendaItemById(id)
    obj.value = {
      ...data,
      meet_date: handleData(data.meet_date)
    }
}
const getAgendaItemById = (id) => {
  for (const date in agendaDetail) {
    const item = agendaDetail[date].find(
      item => item.id === id
    )

    if (item) {
      return item
    }
  }
  return null
}
</script>

<style lang="scss" scoped>
.container {
  background: #f3f3f3;
  padding: 248px 0 43px;
  &Bg {
    width: 100%;
    position: absolute;
    top: 0;
  }
  .agenda {
    width: 90%;
    // width: 1600px;
    margin: 0 auto;
    min-width: 1230px;
    &Top {
      padding: 36px 56px 48px;
      border-radius: 32px;
      background: #ffffff;
      &Back {
        cursor: pointer;
        display: flex;
        align-items: center;
        width: 70px;
        &Text {
          margin-left: 4px;
        }
      }
      &Back:hover {
        color: #2085e9;
      }
      &Nav {
        margin-top: 33px;
        &Title {
          font-size: 32px;
          font-weight: 500;
          line-height: 40px;
          height: 40px;
          display: flex;
          justify-content: space-between;
          &Tab {
            top: -3px;
            display: inline-block;
            width: 88px;
            height: 36px;
            line-height: 36px;
            font-size: 16px;
            border-radius: 8px;
            color: #2085e9;
            background: rgba(32, 133, 233, 0.1);
            text-align: center;
            margin-left: 16px;
          }
          &Replay {
            cursor: pointer;
            display: flex;
            align-items: center;
            font-size: 18px;
            line-height: 16px;
            color: #ffffff;
            background-color: #2085E9;
            border-radius: 8px;
            padding: 6px 12px;
            &Icon {
              width: 26px;
              margin-right: 6px;
            }
          }
          .custom-btn {
              width: 120px;
              height: 40px;
              color: #fff;
              border-radius: 4px;
              font-family: 'Lato', sans-serif;
              font-size: 18px;
              font-weight: 500;
              background: transparent;
              cursor: pointer;
              transition: all 0.3s ease;
              position: relative;
              // display: inline-block;
              display: flex;
              align-items: center;
              justify-content: center;
              box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .5),
                      7px 7px 20px 0px rgba(0, 0, 0, .1),
                      4px 4px 5px 0px rgba(0, 0, 0, .1);
              outline: none;
          }

          .btn {
              background: linear-gradient(0deg, rgb(20, 200, 152) 0%, #00AB7A 100%);
              line-height: 42px;
              padding: 0;
              border: none;
          }

          .btn span {
              position: relative;
              display: block;
              width: 100%;
              height: 100%;
          }

          .btn:before,
          .btn:after {
              position: absolute;
              content: "";
              right: 0;
              bottom: 0;
              background: #00AB7A;
              box-shadow: -7px -7px 20px 0px rgba(255, 255, 255, .9),
                      -4px -4px 5px 0px rgba(255, 255, 255, .9),
                      7px 7px 20px 0px rgba(0, 0, 0, .2),
                      4px 4px 5px 0px rgba(0, 0, 0, .3);
              transition: all 0.3s ease;
          }

          .btn:before {
              height: 0%;
              width: 2px;
          }

          .btn:after {
              width: 0%;
              height: 2px;
          }

          .btn:hover {
              color: #00AB7A;
              background: transparent;
          }

          .btn:hover:before {
              height: 100%;
          }

          .btn:hover:after {
              width: 100%;
          }

          .btn span:before,
          .btn span:after {
              position: absolute;
              content: "";
              left: 0;
              top: 0;
              background: #00AB7A;
              box-shadow: -7px -7px 20px 0px rgba(255, 255, 255, .9),
                      -4px -4px 5px 0px rgba(255, 255, 255, .9),
                      7px 7px 20px 0px rgba(0, 0, 0, .2),
                      4px 4px 5px 0px rgba(0, 0, 0, .3);
              transition: all 0.3s ease;
          }

          .btn span:before {
              width: 2px;
              height: 0%;
          }

          .btn span:after {
              height: 2px;
              width: 0%;
          }

          .btn span:hover:before {
              height: 100%;
          }

          .btn span:hover:after {
              width: 100%;
          }
        }
        &Det {
          display: flex;
          gap: 75px;
          font-size: 16px;
          line-height: 24px;
          color: #525966;
          margin: 32px 0;
          &Img {
            display: flex;
            align-items: center;
          }
          &Time {
            margin: 0 16px 0 8px;
          }
          &Addicon {
            width: 20px;
          }
        }
        &Desc {
          font-size: 16px;
          color: #525966;
        }
      }
    }
    &Bottom {
      margin-top: 32px;
      border-radius: 32px;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(120px);
      padding: 40px 56px 64px;
      &Title {
        display: flex;
        justify-content: space-between;
        font-family: Source Han Sans;
        font-size: 32px;
        font-weight: 500;
        line-height: 40px;
        color: #242933;
        margin-bottom: 20px;
        &Desc {
          font-size: 16px;
          color: #9398a1;
        }
      }
      &Box {
        display: flex;
        // align-items: center;
        min-height: 96px;
        &Line {
          width: 1px;
          height: 85px;
          background: #e5e5e5;
          position: absolute;
          top: 21px;
          left: 4px;
        }
        &Left {
          // background-color: pink;
          width: 50%;
          display: flex;
          align-items: center;
          height: 64px;
        }
        &Circle {
          border: 1px solid #525966;
          width: 9px;
          height: 9px;
          display: inline-block;
          border-radius: 50%;
        }
        &Time {
          margin: 0 24px;
          font-family: Source Han Sans;
          font-size: 20px;
          line-height: 24px;
          color: #8a9099;
          // min-width: 119px;
          min-width: 120px;
        }
        &Title {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 500;
          line-height: 32px;
          color: #3d3d3d;
          // width: 426px;
          // background-color: pink;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          position: relative;
        }
        .guestBox{
          width: 50%;
          display: flex;
          flex-direction: column;
          &Expert {
            margin-left: 40px;
            margin-right: 121px;
            // margin-right: 330px;
            // background-color: palegreen;
            display: flex;
            align-items: center;
            // width: 366px;
            width: 626px;
            margin-bottom: 20px;
            &Icon {
              width: 64px !important;
              height: 64px;
              margin-right: 16px;
              border-radius: 50%;
              overflow: hidden;
              border: 1px solid #e8eaed;
              img {
                width: 100%;
              }
            }
            &Desc {
              display: flex;
              flex-direction: column;
              // background-color: pink;
            }
            &Name {
              font-size: 18px;
              font-weight: 500;
              line-height: 24px;
              color: #3d3d3d;
            }
            &Title {
              width: 268px;
              margin-top: 8px;
              font-size: 16px;
              line-height: 20px;
              color: rgba(61, 61, 61, 0.698);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .expertList{
            display: flex;
            flex-direction: column;
            width: 100%;
            &Item{
              width: 100%;
              margin-bottom: 30px;
              margin-left: 40px;
              display: flex;
              align-items: center;
            &Icon {
              width: 60px;
              height: 60px;
              margin-right: 16px;
              border-radius: 50%;
              overflow: hidden;
              border: 1px solid #e8eaed;
              img {
                width: 100%;
              }
            }
            &Desc {
              width: calc(100% - 150px);
              display: flex;
              flex-direction: column;
              // background-color: pink;
            }
            &Name {
              font-size: 18px;
              font-weight: 500;
              line-height: 24px;
              color: #3d3d3d;
            }
            &Title {
              margin-top: 8px;
              font-size: 16px;
              line-height: 20px;
              color: rgba(61, 61, 61, 0.698);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          }
        }
        &Right {
          position: absolute;
          right: 0;
          display: flex;
          align-items: center;
          font-size: 16px;
          font-weight: normal;
          line-height: 16px;
          color: #525966;
          cursor: pointer;
          &Icon {
            width: 24px;
            margin-right: 8px;
          }
          &Active {
            width: 24px;
            margin-right: 8px;
          }
        }
      }
    }
  }
}
.agendaBottomBox:last-child .agendaBottomBoxLine {
  display: none;
}
.agendaBottomBoxRightActive {
  display: none;
}

.agendaBottomBoxRight:hover .agendaBottomBoxRightIcon {
  display: none;
}

.agendaBottomBoxRight:hover .agendaBottomBoxRightActive {
  display: inline;
}

.agendaBottomBoxRight:hover {
  color: #497ced;
}

:deep(.ant-tooltip-arrow-content) {
  display: none;
}
</style>
